import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    PATH: '',
    TOKEN: '',
    TOKEN_EXPIRES: '',
    ADMIN: false
  },
  mutations: {
    setPath: (state, info) => {
      state.PATH = info
    },
    admin: (state, info) => {
      state.ADMIN = info
    },
    setToken: (state, info) => {
      state.TOKEN = info.token
      state.TOKEN_EXPIRES = info.tokenExpires
    }
  },
  actions: {},
  modules: {}
})
